import { AppLink } from '../../components/AppLink';
import { AppTitle } from '../../components/AppTitle';
import { Button } from '../../components/Button';
import { FlexColPageContainer } from '../../components/FlexColPageContainer';
import { getDebugRing } from '../../lib/devUtils';
import { useUserData } from '../../lib/userData/UserDataProvider';
import { clx } from '../../lib/utils';
import { HandleLoggedIn } from './HandleLoggedIn';
import { LoginForm } from './LoginForm';

export const LoginPage = () => {
  const [userData] = useUserData();
  const isLoggedIn = userData?.firebaseUserId?.trim() !== '';

  return (
    <FlexColPageContainer className={clx('justify-around', getDebugRing('red'))}>
      {/* Handle logged in user */}
      {isLoggedIn && <HandleLoggedIn userData={userData} />}

      {/* App Title */}
      <div
        className={clx('flex basis-1/6 flex-col items-center justify-end', getDebugRing('blue'))}
      >
        <AppTitle className="xs:text-[10vw] sm:text-[64px]" />

        <p className="text-center text-sm">Patch up your mood</p>
      </div>

      {/* Login Form */}
      <div
        className={clx(
          'basis-lg flex min-h-[40px] w-full flex-col overflow-y-auto py-1',
          getDebugRing('orange')
        )}
      >
        <LoginForm
          className={clx(getDebugRing('purple'), 'mx-auto min-h-0 w-full max-w-sm shrink')}
        />
      </div>

      {/* Disclaimer Text */}
      <div
        className={clx(
          'flex w-80 shrink-0 basis-1/12 flex-col justify-center',
          getDebugRing('red')
          // '[@media(max-height:700px)]:grow-0'
        )}
      >
        <p className="px-4 text-center text-sm leading-relaxed">
          By continuing, you agree to our{' '}
          <Button as={AppLink} href="/terms" variant="underline">
            Terms of Service
          </Button>{' '}
          and{' '}
          <Button as={AppLink} href="/privacy" variant="underline">
            Privacy Policy
          </Button>
        </p>
      </div>
    </FlexColPageContainer>
  );
};
